/* sp-chat-flows.js - the flows our shop chat runs, as data.
 *
 * THIS IS THE FILE CLAUDE EDITS. There is no admin screen for it, on Lorenzo's
 * word (25 October 2026): "We do not want a backend of the workflow setup. The
 * setup will be done by you."
 *
 * The words and the order are Gorgias's, copied exactly from the four Gorgias
 * flows as `docs/chat/README.md` records them, and that file is the authority:
 *   Customize a Ring         01KYSD0PVCD9C2BZYTQST6G95A
 *   Use Personal Materials   01KYSE3YNAT3XDB88FWJTVQP1C
 *   Create Something Original 01KYSE2BXAC5056BT8GFDP9BZ5
 *   Heirloom Gold            01KYSDE9XAEQ4FZ7XPV6C2N062
 * all read on 25 October 2026 and last changed in Gorgias 15 August 2026. DO
 * NOT reword, add or reorder a question without Lorenzo.
 *
 * THE EMAIL IS ASKED LAST, AND A PHONE NUMBER AFTER IT. Lorenzo, later on
 * 25 October 2026: "can we collect the email of the customer as the last step
 * and after the email ask them for a number too". Both come after the flow's own
 * questions - before the thank-you where the flow has one (`thanks_step`), and
 * before `finish` where it has none. ORDER MANAGEMENT IS NOT CHANGED: its email
 * still comes first, because the 6-digit code is sent to it.
 *
 * The lines that are OURS and not Gorgias's are all in `strings` below, so
 * changing one is a one-line edit. Lorenzo approved them on 25 October 2026:
 * "the wording is fine".
 *
 * Curly quotes are written as “ and ” so this file is plain ASCII and
 * cannot be mangled by a server that serves it as the wrong character set. The
 * strings themselves still carry the curly characters.
 */
(function (root) {
  'use strict';

  /* Every step of a flow is one of four kinds:
   *
   *   text     a typed answer in the message box
   *   choices  pill buttons; the one pressed becomes the customer's pill
   *   upload   files chosen and sent together
   *   message  the bot says something and nothing is asked
   *
   * `bold` is the first line and `italic` the second. SECOND LINES ARE NOT ALL
   * ITALIC: in Customize a Ring every one of them is `<em>` in Gorgias, but in
   * the other three some are plain text. A step whose second line is plain says
   * so with `second_style: 'plain'`, and the widget then draws it in the body
   * colour and not italic. Anything else (absent, or 'italic') is italic, which
   * keeps every step written before this field existed exactly as it was.
   *
   * `gorgias_step_id` is the id of the matching step in Gorgias, so a Gorgias
   * answer and ours can be lined up. Where Gorgias draws the SAME question twice,
   * once in each branch - the ring size and the thank-you in Customize a Ring and
   * in Create Something Original - ours draws it once and carries both ids, in
   * Gorgias's own order (the first branch, then the second). The widget keys
   * everything on our own `id`.
   *
   * `thanks_step` names the step the email and the phone are asked BEFORE, which
   * is the flow's thank-you. A flow with no thank-you (Use Personal Materials)
   * has `thanks_step: null`, and they are asked when the questions run out.
   *
   * `gorgias_handover_step_id` is the Gorgias step that hands the chat to a
   * person. Ours does the same thing with `finish`, so it is recorded and not
   * used.
   */

  var CUSTOMIZE_A_RING = {
    key: 'customize_a_ring',
    label: 'Customize a Ring',
    /* the mark at the start of its home-screen row (sp-chat.js ICONS) */
    icon: 'ring',
    gorgias_flow_name: 'Customize a Ring',
    first: 'ring',
    thanks_step: 'thanks',
    steps: {
      ring: {
        id: 'ring',
        gorgias_step_id: '01KYMD31XPTBZCRAV55Q84VA1J',
        kind: 'text',
        bold: 'Which ring would you like to customize?',
        italic: 'Paste the product link or product name.',
        next: 'change'
      },
      change: {
        id: 'change',
        gorgias_step_id: '01KYMDCZK6JTR85ES993AWJSCH',
        kind: 'text',
        bold: 'What would you like to change?',
        italic: 'Include any materials, colors, engraving, or design details.',
        next: 'photo_q'
      },
      photo_q: {
        id: 'photo_q',
        gorgias_step_id: '01KYMDR98N51QV4P2BS0DTVJQ8',
        kind: 'choices',
        bold: 'Would you like to upload a photo?',
        italic: null,
        choices: [
          { label: 'Yes', next: 'photo' },
          { label: 'Skip', next: 'size' }
        ],
        next: null
      },
      photo: {
        id: 'photo',
        gorgias_step_id: '01KYMDP3D0PTWBC4BKQQ7288DC',
        kind: 'upload',
        bold: 'Upload a photo, sketch, or inspiration image.',
        /* No full stop at the end of this one. That is how Gorgias has it. */
        italic: 'Select all images at once. You can upload up to 5 files',
        max_files: 5,
        next: 'size'
      },
      size: {
        id: 'size',
        /* after Yes, after Skip */
        gorgias_step_id: ['01KYME1218XJY3RQKTG2T2DYYR', '01KYMDZXP3TC8BHQQ5EWACW9BE'],
        kind: 'text',
        bold: 'Do you know the ring size?',
        /* The quotes around "not sure." are curly in Gorgias and stay curly. */
        italic: 'Enter the size or say “not sure.”',
        next: 'thanks'
      },
      thanks: {
        id: 'thanks',
        /* after Yes, after Skip; Gorgias then hands over to a person */
        gorgias_step_id: ['01KYMDT5H1ZFAMHMJNBN2XBW48', '01KYME0K5QDEW1WDNKFR2TGEDX'],
        kind: 'message',
        bold: 'Thank you! Our team will review your request and reply within one business day.',
        italic: null,
        next: null
      }
    }
  };

  /* ------------------------------------------------- THE OTHER THREE GORGIAS FLOWS
   *
   * Lorenzo, 25 October 2026: "add all the rest of the flows to the chart same as
   * Gorgias". Word for word from `docs/chat/README.md` under "The other three
   * Gorgias flows, word for word", which read them out of Gorgias the same day.
   *
   * A fifth flow, Something Else, exists only on the second Gorgias chat
   * ("Customer Service"), which is not on the shop. IT IS NOT COPIED unless
   * Lorenzo asks.
   */

  /* USE PERSONAL MATERIALS. Three questions and then straight to a person:
     THIS FLOW HAS NO THANK-YOU MESSAGE IN GORGIAS and ours copies that, so
     `thanks_step` is null and the email and the phone are asked when the
     questions run out. */
  var USE_PERSONAL_MATERIALS = {
    key: 'use_personal_materials',
    label: 'Use Personal Materials',
    /* the mark at the start of its home-screen row (sp-chat.js ICONS) */
    icon: 'heart',
    gorgias_flow_name: 'Use Personal Materials',
    gorgias_configuration_id: '01KYSE3YNAT3XDB88FWJTVQP1C',
    first: 'material',
    thanks_step: null,
    gorgias_handover_step_id: '01KYMCPPTH8F8J5DS5G4Y24Z6G',
    steps: {
      material: {
        id: 'material',
        gorgias_step_id: '01KYMG9Y2P7FSE0EHMS4Z3279A',
        kind: 'text',
        bold: 'What personal material would you like us to use?',
        italic: 'For example: ashes, fur, fabric, wood, sand, stone, or another meaningful material.',
        next: 'how'
      },
      how: {
        id: 'how',
        gorgias_step_id: '01KYMEC4N26X74Q5K13EGHKS46',
        kind: 'text',
        bold: 'How would you like it incorporated into the ring?',
        /* “not sure” here has NO full stop inside the quotes, unlike the
           ring-size line below. That is how Gorgias has it. */
        italic: 'For example: as an inlay, interior sleeve, or subtle detail. Say “not sure” if you would like our recommendation.',
        next: 'size'
      },
      size: {
        id: 'size',
        gorgias_step_id: '01KYMECJJNQWFJFKYC44F7CHQE',
        kind: 'text',
        bold: 'Do you know the ring size?',
        italic: 'Enter the size or say “not sure.”',
        next: null
      }
    }
  };

  /* CREATE SOMETHING ORIGINAL. One question with two buttons - Yes and NOT YET,
     which is Gorgias's word here and not the Skip of the photo question - and
     then two branches that join again at the ring size. Gorgias draws the ring
     size and the thank-you once in each branch, so ours draws each once and
     carries both ids. */
  var CREATE_SOMETHING_ORIGINAL = {
    key: 'create_something_original',
    label: 'Create Something Original',
    /* the mark at the start of its home-screen row (sp-chat.js ICONS) */
    icon: 'sparkles',
    gorgias_flow_name: 'Create Something Original',
    gorgias_configuration_id: '01KYSE2BXAC5056BT8GFDP9BZ5',
    first: 'sketch_q',
    thanks_step: 'thanks',
    /* after Yes, after Not yet */
    gorgias_handover_step_id: ['01KYMCP5PMM5SVYQ3RM41MPSJJ', '01KYMFK3PWWNHBFJWNJ8DPNJE6'],
    steps: {
      sketch_q: {
        id: 'sketch_q',
        gorgias_step_id: '01KYMDJDENXTSXRSFYWFVFK742',
        kind: 'choices',
        bold: 'Do you have a photo or sketch of your idea?',
        italic: null,
        choices: [
          { label: 'Yes', next: 'upload' },
          { label: 'Not yet', next: 'describe' }
        ],
        next: null
      },
      upload: {
        id: 'upload',
        gorgias_step_id: '01KYMDWZCA74D1VTAG1GTMXQ8Z',
        kind: 'upload',
        bold: 'Upload a photo, sketch, or inspiration image.',
        /* no full stop at the end, the same as Customize a Ring's */
        italic: 'Select all images at once. You can upload up to 5 files',
        max_files: 5,
        next: 'create'
      },
      create: {
        id: 'create',
        gorgias_step_id: '01KYMDJBN1J2DWPSSGW7PQRQS3',
        kind: 'text',
        bold: 'Tell us what you would like us to create.',
        /* no second line at all in Gorgias */
        italic: null,
        next: 'size'
      },
      describe: {
        id: 'describe',
        gorgias_step_id: '01KYMFKM5B0YMGYM8DF5RJFCFG',
        kind: 'text',
        bold: 'No problem. You can describe your idea below. Photos or sketches can help, but they are not required.',
        /* PLAIN, not italic: the same words as `create`'s first line, asked as
           the second line of this one. */
        italic: 'Tell us what you would like us to create.',
        second_style: 'plain',
        next: 'size'
      },
      size: {
        id: 'size',
        /* after Yes, after Not yet */
        gorgias_step_id: ['01KYMDYEW4KJ7WX48SBV1XE03F', '01KYMFMC382THHGNPHPA5YBFZW'],
        kind: 'text',
        bold: 'Do you know the ring size?',
        italic: 'Enter the size or say “not sure.”',
        next: 'thanks'
      },
      thanks: {
        id: 'thanks',
        /* after Yes, after Not yet; Gorgias then hands over to a person */
        gorgias_step_id: ['01KYMDVWHM2J6SEEXW7MH5YCJC', '01KYMFN0NVY0JQSP3RVAT9ZZ0J'],
        kind: 'message',
        bold: 'Thank you! Our team will review your request and reply within one business day.',
        italic: null,
        next: null
      }
    }
  };

  /* HEIRLOOM GOLD. It opens with a message rather than a question, and THREE of
     its four second lines are PLAIN. Gorgias's own text carries a leading space
     on the plain ones (`<div> Our team…`); it does not show, so it is not
     copied. */
  var HEIRLOOM_GOLD = {
    key: 'heirloom_gold',
    label: 'Heirloom Gold',
    /* the mark at the start of its home-screen row (sp-chat.js ICONS) */
    icon: 'gold',
    gorgias_flow_name: 'Heirloom Gold',
    gorgias_configuration_id: '01KYSDE9XAEQ4FZ7XPV6C2N062',
    first: 'intro',
    thanks_step: 'thanks',
    gorgias_handover_step_id: '01KYMCPQJDG104PBQHTF33N9GV',
    steps: {
      intro: {
        id: 'intro',
        gorgias_step_id: '01KYMEE5H5CEV63F1P25G4N90G',
        kind: 'message',
        bold: 'We can reuse your heirloom gold to create a new ring while preserving its sentimental value.',
        italic: 'Our team will first review the metal, karat, weight, and design to confirm what is possible.',
        second_style: 'plain',
        next: 'karat'
      },
      karat: {
        id: 'karat',
        gorgias_step_id: '01KYMEDS0Z8545E4XNXA3XP9HX',
        kind: 'text',
        bold: 'Do you know the karat and approximate weight of the gold?',
        italic: 'Enter what you know, or say “not sure.”',
        second_style: 'plain',
        next: 'look'
      },
      look: {
        id: 'look',
        gorgias_step_id: '01KYMEHBHX5GVAJ8Q32XESMYDN',
        kind: 'text',
        bold: 'What would you like the new ring to look like?',
        italic: 'Include the style, width, finish, materials, or any details you want to preserve.',
        second_style: 'plain',
        next: 'size'
      },
      size: {
        id: 'size',
        gorgias_step_id: '01KYMEJ4FA0DDFNY2HR3HH7P2D',
        kind: 'text',
        bold: 'Do you know the ring size?',
        /* THIS one is italic in Gorgias, the same as every other ring-size line */
        italic: 'Enter the size or say “not sure.”',
        next: 'thanks'
      },
      thanks: {
        id: 'thanks',
        gorgias_step_id: '01KYMEK0YKC0YPACQDADS93P7P',
        kind: 'message',
        bold: 'Thank you! Our team will review your request and reply within one business day.',
        italic: null,
        next: null
      }
    }
  };

  /* --------------------------------------------------------- THE WEDDING RING FLOW
   *
   * The wedding-dress page's own flow. Lorenzo, 25 October 2026: "There will
   * also be a new chat added for Wedding dress ... when the customer using this
   * chat with us, we dont want to show them the customise ring or any other chat
   * option, we start with a chat about wedding rings. page is
   * https://sestosynergy.com/pages/wedding-dress-ring".
   *
   * THE QUESTIONS ARE CUSTOMIZE A RING'S, WORD FOR WORD AND IN THE SAME ORDER,
   * LESS THE PHOTO QUESTION. Lorenzo, later the same day: "we will start with
   * wedding dress questions same as the customize the ring but later switch to
   * AI agent." Then, of "Would you like to upload a photo?": "remove this
   * question" - for this flow only, he chose; Customize a Ring keeps it. The
   * upload a Yes led to went with it. The steps are written out here and not
   * shared with CUSTOMIZE_A_RING, which is what let this one change on its own.
   * `docs/chat/README.md` holds them under "The wedding ring flow".
   *
   * NO `gorgias_step_id`s. There is no Gorgias flow for this one, and borrowing
   * Customize a Ring's ids would line its answers up with the wrong flow.
   *
   * THE LABEL IS HIS: "Wedding ring", chosen 25 October 2026. It is the same name
   * shop-chat's ticket subject and the ERP's Chats screen use. The home screen
   * never lists this flow, so in the widget the label shows only as the row's
   * name in "Your previous chats". It is NEVER drawn as the customer's opening
   * pill, because they pressed no row: sp-chat.js `isPageFlow` keeps it off for
   * every flow in `PAGES` below.
   *
   * Like every question flow it ends with the email and then the phone, asked
   * before `thanks_step`.
   */
  var WEDDING_RING = {
    key: 'wedding_ring',
    label: 'Wedding ring',
    first: 'ring',
    thanks_step: 'thanks',
    steps: {
      ring: {
        id: 'ring',
        kind: 'text',
        bold: 'Which ring would you like to customize?',
        italic: 'Paste the product link or product name.',
        next: 'change'
      },
      change: {
        id: 'change',
        kind: 'text',
        bold: 'What would you like to change?',
        italic: 'Include any materials, colors, engraving, or design details.',
        next: 'size'
      },
      size: {
        id: 'size',
        kind: 'text',
        bold: 'Do you know the ring size?',
        italic: 'Enter the size or say “not sure.”',
        next: 'thanks'
      },
      thanks: {
        id: 'thanks',
        kind: 'message',
        bold: 'Thank you! Our team will review your request and reply within one business day.',
        italic: null,
        next: null
      }
    }
  };

  /* ------------------------------------------------------------ ORDER MANAGEMENT
   *
   * Lorenzo asked for this on 25 October 2026: "can we also add the order
   * management? Linked with the ERP instead of the Shopify? The customer can
   * start the chat usign their email or channel reference." He then chose email,
   * a 6-digit code sent to that email, and then the whole list of their orders.
   *
   * THE WORDS HERE ARE GORGIAS'S, copied exactly from `docs/chat/README.md`
   * under "Order management, from the ERP" and "The seven Report issue scenarios,
   * word for word from Gorgias". The seven scenarios are in Gorgias's order, the
   * options inside each are in Gorgias's order, and every label and every reply
   * is Gorgias's. MOST OF THESE ARE GORGIAS'S STOCK WORDING AND NOT LORENZO'S -
   * "nationwide shipping volume", and Delivered's refund option, whose reply
   * talks about a cancelled order. They are copied exactly, as asked, and the
   * ones worth his look are listed on the area page.
   *
   * `helpful: true` is Gorgias's "Ask customers if your response was helpful"
   * switch, and it decides what happens next. The options WITHOUT it are the ones
   * whose reply asks the customer something ("What would you like to reorder?",
   * "How can we help you?"), so what they type has to reach a person. The ones
   * WITH it are answered outright, so the chat asks whether that helped and only
   * a "I need more help" makes work for the team. There are 16 of them.
   *
   * CANCEL ORDER IS NOT HERE. Gorgias has it switched on with no order status
   * picked and no reply written, so Gorgias never offers it. Ours does not offer
   * it either. Lorenzo can say otherwise.
   *
   * The scenario is decided by the ERP, not here: the server sends one of
   * `refunded`, `cancelled`, `processing`, `failed`, `shipped`, `delivered` or
   * `fallback` on the order, and the widget shows that scenario's options.
   */

  /* The replies Gorgias uses in more than one place, written once. The wording
   * check compares EVERY option against the README on its own, so if Gorgias ever
   * changes one of them and not the others, the check fails and the shared one is
   * split - it cannot drift quietly. */
  var R_OTHER = 'How can we help you?';
  var R_REORDER = 'Happy to help! What would you like to reorder?';
  var R_NO_EDIT = 'At this time we are unable to modify already placed orders.';
  var R_DISCOUNT =
    'Please provide us with the discount code you forgot to apply so we can further check into this for you.';
  var R_DELAY_DELIVERY =
    'Due to nationwide shipping volume, you may experience a delay in receiving your order. Please allow a few more business days for the order to reach you.';
  var R_REFUND_ON_CANCEL =
    'If your account was charged, a refund has been issued back to the original method of payment when the order was canceled. We would like to kindly ask you to allow up to 5 business days for the amount to reflect into your account.';

  var ORDERS = {
    key: 'orders',
    /* the home pill. OURS, NOT GORGIAS'S: needs Lorenzo's OK. */
    label: 'Track or manage an order',
    gorgias_flow_name: 'Order management',
    /* `kind` tells the widget this is not a list of questions but the order
       screens. There is no `first` and no `steps`. */
    kind: 'orders',

    /* The three actions offered on a chosen order, in Gorgias's order and with
       Gorgias's labels. `needs: 'can_return'` is why Return order is offered only
       on an order delivered less than 30 days ago, which is Gorgias's own
       condition ("Order delivered less than 30 days ago"). */
    actions: [
      { id: 'track', label: 'Track order' },
      { id: 'return', label: 'Return order', needs: 'can_return' },
      { id: 'issue', label: 'Report issue' }
    ],

    /* Gorgias's Track order reply for an order that has NOT shipped, word for
       word. A shipped order is answered with its own stage, ship-by and tracking
       link instead, because this text says the ring is still being made. */
    track_not_shipped_reply:
      "Thanks for checking on your order! Your ring is being handcrafted just for you, so it's currently in production. Made-to-order rings take some time to complete, and you'll receive an email with tracking as soon as yours ships. If you have a date you need it by, reply here and our team will be happy to help.",

    /* Gorgias's Return order reply, word for word, KEEPING ITS LINE BREAKS: four
       paragraphs, with the address on a line of its own under "please post your
       ring to:", AND A SPACE AT THE VERY END. The trailing space is Gorgias's and
       is not a mistake - do not tidy it away. */
    return_reply:
      'Thanks for your request. We accept returns within 30 days of delivery, provided the ring is unworn and in its original condition.\n'
      + '\n'
      + "Please note: custom and engraved rings are made specifically for you and can't be returned. If your ring was personalised or made to order, please reach out before sending anything back.\n"
      + '\n'
      + 'For eligible returns, please post your ring to:\n'
      + 'Sesto Synergy, 850 Saint Paul St, Suite 16, Rochester, NY 14605\n'
      + '\n'
      + "You cover return postage, and we'd recommend using a tracked and insured service, since rings are small and valuable. Once we receive and check your ring, we'll initiate your refund the same day, it can then take up to 10 days for your bank to process it and for the funds to appear. ",

    /* The seven Report issue scenarios, in the order Gorgias checks them.
       `condition` is Gorgias's own words for when the scenario applies; the ERP
       decides it from its own facts and sends the answer as `scenario`. */
    scenarios: {
      refunded: {
        key: 'refunded',
        label: 'Refunded',
        condition: 'If order has being fully or partially refunded.',
        options: [
          {
            label: "I didn't get my refund",
            helpful: true,
            reply: "Please note a refund was issued back to the original method of payment. Please allow up to 5 business days for the refund to be reflected on your account. If it's been more than 5 business days, let us know you need more help."
          },
          { label: "I'd like to reorder some items", helpful: false, reply: R_REORDER },
          { label: 'Other', helpful: false, reply: R_OTHER }
        ]
      },
      cancelled: {
        key: 'cancelled',
        label: 'Cancelled',
        condition: 'If order has been cancelled.',
        options: [
          { label: "I'd like to get a refund for this order", helpful: true, reply: R_REFUND_ON_CANCEL },
          { label: "I'd like to reorder some items", helpful: false, reply: R_REORDER },
          { label: 'Other', helpful: false, reply: R_OTHER }
        ]
      },
      processing: {
        key: 'processing',
        label: 'Processing',
        condition: 'If order is unfulfilled, pending fulfillment or pending delivery.',
        options: [
          { label: 'I forgot to apply my discount code', helpful: false, reply: R_DISCOUNT },
          { label: "I'd like to edit my order", helpful: true, reply: R_NO_EDIT },
          { label: "I'm past my expected delivery date", helpful: true, reply: R_DELAY_DELIVERY },
          {
            label: 'My order should have shipped by now',
            helpful: true,
            reply: 'Due to nationwide shipping volume, you may experience a delay in receiving your order. Please allow another business day to receive a tracking number.'
          },
          { label: 'Other', helpful: false, reply: R_OTHER }
        ]
      },
      failed: {
        key: 'failed',
        label: 'Failed',
        condition: 'If order is fulfillment or delivery failed.',
        options: [
          {
            label: "I'd like a discount code",
            helpful: true,
            reply: "Thanks for reaching out. We don't have any discount codes to share with you at the moment."
          },
          { label: "I'd like to reorder some items", helpful: false, reply: R_REORDER },
          { label: "I'd like to edit my order", helpful: true, reply: R_NO_EDIT },
          { label: 'Other', helpful: false, reply: R_OTHER }
        ]
      },
      shipped: {
        key: 'shipped',
        label: 'Shipped',
        condition: 'If order has shipped or delivery is ongoing.',
        options: [
          { label: 'I forgot to apply my discount code', helpful: false, reply: R_DISCOUNT },
          { label: "I'd like to change my shipping address", helpful: true, reply: R_NO_EDIT },
          { label: "I'd like to change the delivery date", helpful: true, reply: R_NO_EDIT },
          {
            label: 'My order has been stuck in transit',
            helpful: false,
            reply: "We're very sorry to hear this. Someone will get back to you shortly to help you solve this issue."
          },
          { label: "I'm past my expected delivery date", helpful: true, reply: R_DELAY_DELIVERY },
          { label: "I'd like to edit my order", helpful: true, reply: R_NO_EDIT },
          { label: 'Other', helpful: false, reply: R_OTHER }
        ]
      },
      delivered: {
        key: 'delivered',
        label: 'Delivered',
        condition: 'If order has been delivered.',
        options: [
          {
            label: 'My order was damaged in delivery',
            helpful: false,
            reply: "We're very sorry to hear this. Please provide us with a few more details regarding the damage to the items and let us know if the shipping box was also damaged."
          },
          {
            label: 'The items in my order are defective',
            helpful: false,
            reply: "We're very sorry to hear this. Please provide us with a few more details regarding the defect you noticed."
          },
          {
            label: 'The items are different from what I ordered',
            helpful: false,
            reply: "We're very sorry to hear this. Please let us know exactly what item/color/size you actually received."
          },
          {
            label: 'Some items are missing from my order',
            helpful: false,
            /* Gorgias's own straight quotes round "need more help" */
            reply: 'We\'re very sorry to hear this. You can click on "need more help" to let us know exactly what items you didn\'t receive.'
          },
          { label: "I'd like to get a refund for this order", helpful: true, reply: R_REFUND_ON_CANCEL },
          { label: "I'd like to edit my order", helpful: true, reply: R_NO_EDIT },
          { label: 'Other', helpful: false, reply: R_OTHER }
        ]
      },
      fallback: {
        key: 'fallback',
        label: 'Fallback',
        condition: 'When order status is unavailable or no other scenario applies.',
        options: [
          { label: "I'm past my expected delivery date", helpful: true, reply: R_DELAY_DELIVERY },
          { label: "I'd like to change my shipping address", helpful: true, reply: R_NO_EDIT },
          { label: "I'd like to edit my order", helpful: true, reply: R_NO_EDIT },
          { label: 'I forgot to apply my discount code', helpful: false, reply: R_DISCOUNT },
          { label: 'Other', helpful: false, reply: R_OTHER }
        ]
      }
    },

    /* The order the ERP checks the scenarios in, which is Gorgias's order.
       Only used to read the file back in the right order; the server decides. */
    scenario_order: ['refunded', 'cancelled', 'processing', 'failed', 'shipped', 'delivered', 'fallback']
  };

  /* THREE INVENTED ORDERS, FOR PRACTICE MODE ONLY. They are not real and no
   * customer has ever had them: the numbers start #P for practice, the customer
   * is "Practice Customer" and the tracking link goes to example.com, which is
   * the address set aside for examples and is nobody's shop. The ring names are
   * ours ("The Quest", "The Aurora") because a made-up ring name would teach
   * Lorenzo the wrong thing about the layout.
   *
   * One being made, one shipped with tracking, one delivered 10 days ago so
   * Return order is offered on it - the three states the screen has to draw.
   * The dates are worked out from the day the preview is opened, so the preview
   * never shows a stale "Ordered" date.
   */
  function practiceOrders(todayMs) {
    function day(back) {
      return new Date(todayMs - back * 86400000).toISOString().slice(0, 10);
    }
    return [
      {
        id: 'p-1001',
        ref: '#P1001',
        channel: 'Shopify',
        placed_at: day(9),
        items: [{ name: 'The Quest', detail: 'Size 10 1/4, meteorite inlay, engraved inside' }],
        stage: 'Being made now',
        ship_by: day(-12),
        tracking: null,
        shipped_at: null,
        delivered_at: null,
        can_return: false,
        scenario: 'processing'
      },
      {
        id: 'p-1002',
        ref: '#P1002',
        channel: 'Etsy',
        placed_at: day(24),
        items: [{ name: 'The Aurora', detail: 'Size 7, 8mm, polished' }],
        stage: 'On its way to you',
        ship_by: day(5),
        tracking: {
          carrier: 'USPS',
          number: 'PRACTICE-0000-0002',
          url: 'https://example.com/practice-tracking/0002'
        },
        shipped_at: day(4),
        delivered_at: null,
        can_return: false,
        scenario: 'shipped'
      },
      {
        id: 'p-1003',
        ref: '#P1003',
        channel: 'Shopify',
        placed_at: day(41),
        items: [
          { name: 'The Quest', detail: 'Size 9, wood inlay' },
          { name: 'Ring sizer', detail: 'Free with the order' }
        ],
        stage: 'Delivered',
        ship_by: day(21),
        tracking: {
          carrier: 'USPS',
          number: 'PRACTICE-0000-0003',
          url: 'https://example.com/practice-tracking/0003'
        },
        shipped_at: day(14),
        delivered_at: day(10),
        can_return: true,
        scenario: 'delivered'
      }
    ];
  }

  /* TWO INVENTED PAST CHATS, FOR PRACTICE MODE ONLY. They are not real and
   * nobody has ever had them: the tokens start `practice-past`, the email is
   * `practice@example.com` - example.com is the address set aside for examples
   * and is nobody's inbox - and the order they talk about is the invented
   * #P1003 above. They exist so the preview can show "Your previous chats" and
   * what one looks like when it is opened, which is most of what this change is.
   *
   * Each one carries BOTH shapes the widget meets: the `token` this browser
   * would have kept, the `id` the server would have sent after the code, and a
   * `transcript` in the shape `resume` and `history_view` answer. One is a
   * Customize a Ring chat a person answered; the other an order chat that went
   * to email, so the preview shows a question flow redrawn from the flow file
   * AND an order chat redrawn from its recorded answers.
   */
  function practiceHistory(todayMs) {
    function when(backDays, mins) {
      return new Date(todayMs - backDays * 86400000 + (mins || 0) * 60000).toISOString();
    }
    var ring = {
      token: 'practice-past-ring',
      id: 9101,
      flow_key: 'customize_a_ring',
      status: 'closed',
      started_at: when(6),
      last_at: when(6, 14),
      transcript: {
        ok: true,
        status: 'closed',
        flow_key: 'customize_a_ring',
        email: 'practice@example.com',
        current_step: 'thanks',
        answers: {},
        started_at: when(6),
        finished_at: when(6, 6),
        verified_at: null,
        order_id: null,
        order_ref: null,
        messages: [
          { id: 1, sender: 'customer', name: null, step_id: 'ring',
            body: 'The Quest', attachments: [], created_at: when(6, 1) },
          { id: 2, sender: 'customer', name: null, step_id: 'change',
            body: 'A wider band, 8mm, with a meteorite inlay',
            attachments: [], created_at: when(6, 2) },
          { id: 3, sender: 'customer', name: null, step_id: 'photo_q',
            body: 'Yes', attachments: [], created_at: when(6, 3) },
          { id: 4, sender: 'customer', name: null, step_id: 'photo',
            body: '2 files',
            attachments: [{ path: 'practice/0', name: 'inspiration.jpg' },
                          { path: 'practice/1', name: 'my-sketch.png' }],
            created_at: when(6, 4) },
          { id: 5, sender: 'customer', name: null, step_id: 'size',
            body: '10 1/4', attachments: [], created_at: when(6, 5) },
          { id: 6, sender: 'team', name: 'Sesto Synergy', step_id: null,
            body: 'We can do all of that - I will send you a drawing tomorrow.',
            attachments: [], created_at: when(6, 12) },
          { id: 7, sender: 'system', name: null, step_id: null,
            body: 'This chat has ended. Thank you!',
            attachments: [], created_at: when(6, 14) }
        ]
      }
    };
    var order = {
      token: 'practice-past-order',
      id: 9102,
      flow_key: 'orders',
      status: 'emailed',
      started_at: when(2),
      last_at: when(2, 4),
      transcript: {
        ok: true,
        status: 'emailed',
        flow_key: 'orders',
        email: 'practice@example.com',
        current_step: 'details',
        answers: {
          order_action: { question: 'What would you like to do?', value: 'Report issue' },
          issue: { question: 'What would you like help with?',
                   value: 'My order was damaged in delivery' },
          details: { question: 'Tell us a bit more and our team will help.',
                     value: 'The box was crushed on one corner.' }
        },
        started_at: when(2),
        finished_at: when(2, 4),
        verified_at: when(2, 1),
        order_id: 1003,
        order_ref: '#P1003',
        messages: [
          { id: 11, sender: 'system', name: null, step_id: null,
            body: 'Email confirmed.', attachments: [], created_at: when(2, 1) },
          { id: 12, sender: 'customer', name: null, step_id: 'order_action',
            body: 'Report issue', attachments: [], created_at: when(2, 2) },
          { id: 13, sender: 'customer', name: null, step_id: 'issue',
            body: 'My order was damaged in delivery',
            attachments: [], created_at: when(2, 3) },
          { id: 14, sender: 'customer', name: null, step_id: 'details',
            body: 'The box was crushed on one corner.',
            attachments: [], created_at: when(2, 4) },
          { id: 15, sender: 'system', name: null, step_id: null,
            body: "We'll reply to practice@example.com.",
            attachments: [], created_at: when(2, 4) }
        ]
      }
    };
    /* newest first, the order the widget draws them in */
    return [order, ring];
  }

  /* WORDING THAT IS OURS, NOT GORGIAS'S. Word for word from the five bullets in
   * `docs/chat/README.md` under "Wording that is ours, not Gorgias's". Each one
   * was approved by Lorenzo on 25 October 2026. `{email}` is replaced with the address the customer
   * gave. */
  var STRINGS = {
    email_bold: "What's your email address?",
    email_italic: "We'll send our reply there if you leave the chat.",

    /* THE PHONE QUESTION, asked straight after the email and OPTIONAL: Lorenzo
     * asked for it on 25 October 2026 ("after the email ask them for a number
     * too"), chose optional, and APPROVED THESE WORDS the same day. They are
     * word for word from `docs/chat/README.md` under "The email moves to the end,
     * and a phone number follows it". The Skip button beside the box carries the
     * same word as the photo question's Skip - see `ui.skip`. */
    phone_bold: "What's your phone number?",
    phone_italic: "Optional. Press Skip if you'd rather we only email you.",

    after_thanks_live: 'Someone from our team will reply here in a few minutes.',
    after_thanks_email: "We'll reply to {email}.",
    no_answer: "Sorry we couldn't reply in time. We'll email you at {email} within one business day.",
    chat_ended: 'This chat has ended. Thank you!',

    /* ORDER MANAGEMENT. Every line below is OURS and NOT GORGIAS'S. The six just
     * below are word for word from `docs/chat/README.md`'s two "Wording that is
     * ours" lists, and LORENZO APPROVED THEM on 25 October 2026: "the wording is
     * fine, go ahead". */
    orders_code_sent:
      "If we have orders under that email, we've sent you a 6-digit code. It can take a minute to arrive.",
    code_bold: 'Type the 6-digit code from the email.',
    code_bad: "That code doesn't match. Please check the email and try again.",
    orders_none:
      "We couldn't find any orders under that email. If you ordered with a different email, try that one.",
    helpful_bold: 'Was this helpful?',
    more_help: 'Tell us a bit more and our team will help.',

    /* These six are NOT in the README: they are lines the screen turned out to
     * need once it was built, so they were not in the README's lists. They were
     * put to him separately and LORENZO APPROVED THEM on 25 October 2026: "the
     * wording is fine, go ahead".
     *   - the code can also come back expired or locked, and both have to say
     *     what to do next;
     *   - the three actions and the Report issue options need something asked
     *     above them, or a reader meets a row of buttons with no question;
     *   - "Yes, thanks" ends the chat without a person, so it needs an ending of
     *     its own: `chat_ended` is for a LIVE chat a colleague closed;
     *   - and an orders chat picked up on another page says why it is asking for
     *     the email again. */
    code_expired: 'That code has run out. A code lasts 10 minutes, so please start again.',
    code_locked: "That's too many tries, so this code has been stopped. Please start again.",
    order_actions_bold: 'What would you like to do?',
    issue_bold: 'What would you like help with?',
    self_served_end: 'Glad that helped. You can start another chat any time.',
    orders_again: "Let's find your orders again."
  };

  /* CONTROL LABELS AND THE ONE ERROR LINE. These are not message wording: they
   * are what is written on a button, in a placeholder or under a field. The
   * ones marked (measured) were read off the live Gorgias widget on 25 October
   * 2026; the ones marked (ours) are new and are listed in this folder's
   * README so Lorenzo can change them. */
  var UI = {
    home_title: 'Chat with us',          /* (measured) */
    placeholder: 'Type a message...',    /* (measured) */
    privacy: 'Privacy',                  /* (measured) */
    send: 'Send',                        /* (ours) button label for screen readers */
    back: 'Back to the start',           /* (ours) */
    close: 'Close chat',                 /* (ours) */
    open: 'Chat with us',                /* launcher label, same words as the title */
    practice: 'Practice',                /* (ours) the practice-mode badge */
    choose_files: 'Choose files',        /* (ours) */
    add_more: 'Add more',                /* (ours) */
    remove_file: 'Remove',               /* (ours) */
    send_files: 'Send',                  /* (ours) */
    bad_email: 'Please check the email address.',                 /* (ours) */
    too_many_files: 'You can send up to 5 files.',                /* (ours) */

    /* THE PHONE QUESTION'S OWN THREE CONTROL WORDS (25 October 2026).
     *   `skip` is NOT a new word: it is the same word the photo question's Skip
     *     carries, and `docs/chat/README.md` says so outright ("with a **Skip**
     *     button (the same word as the photo question's Skip)"). It is written
     *     here rather than taken from that flow's choice list because the phone
     *     question is ours and belongs to no flow.
     *   `phone_label` and `bad_phone` ARE NEW WORDS AND NEED LORENZO'S OK. They
     *     are the field's name and the quiet line under it when what was typed is
     *     not a phone number, written by exact analogy with the email's
     *     `bad_email` above, which he approved. Nothing can be shown without
     *     them, so they are the smallest thing that could be written and the
     *     easiest to change: one line each. */
    skip: 'Skip',                                                 /* the photo question's own word */
    phone_label: 'Phone number',                                  /* (ours) NEEDS LORENZO'S OK */
    bad_phone: 'Please check the phone number.',                  /* (ours) NEEDS LORENZO'S OK */

    file_too_big: 'Each file has to be under 15 MB.',             /* (ours) */
    wrong_file_kind: 'Please choose images or PDF files.',        /* (ours) */
    error: 'Something went wrong. Please try again.',             /* (ours) */
    retry: 'Try again',                                           /* (ours) */

    /* ORDER MANAGEMENT controls, all (ours). The three field labels on an order
       card - Ordered, Ship by, Tracking - "Back to my orders" and the helpful
       buttons are in the README's list, which Lorenzo approved on 25 October
       2026; the rest are what a button or a field had to be called. */
    orders_ordered: 'Ordered',
    orders_ship_by: 'Ship by',
    orders_tracking: 'Tracking',
    back_to_orders: 'Back to my orders',
    helpful_yes: 'Yes, thanks',
    helpful_more: 'I need more help',
    new_code: 'Send a new code',
    code_label: '6-digit code',
    code_wrong_shape: 'The code is 6 numbers.',
    orders_open: 'Choose this order',               /* for a reader, on a card */

    /* CHAT HISTORY (25 October 2026). Lorenzo asked for it - "how can we
     * preserve the chat of a customer. So that when the same customer returns
     * they see their chat hisotyr" - and chose both ways and twelve months of
     * keeping. THESE TWO LINES ARE NEW AND NEED LORENZO'S OK: they are the
     * heading above the list and the quiet link that clears it. They are the
     * only new words the whole thing needed - a past chat opens with no message
     * box and "Back to the start" at its foot, which says it is finished
     * without a sentence saying so. */
    previous_chats: 'Your previous chats',          /* (ours) NEEDS LORENZO'S OK */
    forget_device: 'Remove from this device'        /* (ours) NEEDS LORENZO'S OK */
  };

  /* THE HOME SCREEN. The order and the labels of the pills come from here.
   * ALL FOUR GORGIAS FLOWS ARE ON IT SINCE 25 October 2026, on Lorenzo's word
   * ("add all the rest of the flows to the chart same as Gorgias"), AND THE
   * ORDER IS GORGIAS'S OWN - the order its chat's `automation-settings` lists
   * the entrypoints in: Customize a Ring, Use Personal Materials, Create
   * Something Original, Heirloom Gold. Our own order row comes after them.
   *
   * WEDDING RINGS IS DELIBERATELY NOT HERE. It is reached only from its own
   * page, through `PAGES` below. */
  var HOME = {
    title: UI.home_title,
    flows: ['customize_a_ring', 'use_personal_materials',
            'create_something_original', 'heirloom_gold'],
    /* The order row sits BELOW the flow rows and is drawn on its own, because
       it is not one of Gorgias's question flows: it asks for an email, sends a
       code and then shows what the ERP holds. */
    orders: 'orders',
    /* HIDDEN FOR NOW. Lorenzo, 25 October 2026: "remove the Track or manage an
       order for now. hide it." The row is not drawn and no theme command opens
       it; the flow, its wording and the server's side are all kept, so turning
       this back to true is the whole of bringing it back. While it is hidden, a
       customer's past chats from ANOTHER device are out of reach too, because
       that list comes after the order row's 6-digit code; the ones kept in this
       browser are still on the home screen. */
    show_orders: false
  };

  /* PAGE MODE: A PAGE THAT IS ONE FLOW AND NOTHING ELSE.
   *
   * Lorenzo, 25 October 2026, about the wedding-dress page: "we dont want to
   * show them the customise ring or any other chat option, we start with a chat
   * about wedding rings".
   *
   * The key is `location.pathname`, exactly, and the value is the flow key. On a
   * page listed here the launcher, `GorgiasChat.open()`, every
   * `#open-gorgias-chat` link and the page's own `[data-spdr-chat]` button all go
   * straight into that flow: no home screen, no other flow, no order row, and no
   * way back to the home screen from the header.
   *
   * THE WIDGET ONLY TURNS IT ON FOR A FLOW THAT EXISTS AND HAS STEPS, so a page
   * named here whose flow is still a placeholder behaves exactly like any other
   * page. Adding the next such page is a one-line change here. */
  var PAGES = {
    '/pages/wedding-dress-ring': 'wedding_ring'
  };

  root.SPChatFlows = {
    version: '5 (25 October 2026: the email and phone at the end, all four Gorgias flows, page mode, the wedding ring flow)',
    home: HOME,
    pages: PAGES,
    flows: {
      customize_a_ring: CUSTOMIZE_A_RING,
      use_personal_materials: USE_PERSONAL_MATERIALS,
      create_something_original: CREATE_SOMETHING_ORIGINAL,
      heirloom_gold: HEIRLOOM_GOLD,
      wedding_ring: WEDDING_RING,
      orders: ORDERS
    },
    strings: STRINGS,
    ui: UI,
    /* practice mode only; see practiceOrders and practiceHistory above */
    practiceOrders: practiceOrders,
    practiceHistory: practiceHistory
  };
}(typeof window !== 'undefined' ? window : globalThis));
